import React from 'react'

export default function FolderPathArrow() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginBottom: '-1px', marginLeft: '3px' }}
    >
      <path
        d="M7.91602 6.24984L5.41602 8.74984L4.82435 8.15817L6.32018 6.6665H1.66602V1.6665H2.49935V5.83317H6.32018L4.82435 4.3415L5.41602 3.74984L7.91602 6.24984Z"
        fill="#3249D7"
      />
    </svg>
  )
}
